import { NotAvailableWrapper } from 'pages/integrations/components/notAvailable/NotAvailable.styles';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
import theme from 'styles/theme';

export const PropertyDetailsColumnStyled = styled(Col).attrs<{
  $isChildProperty?: boolean;
}>(() => ({
  xs: 12,
  md: 5,
}))<{ $isChildProperty?: boolean }>`
  align-items: start;
  display: flex;
  gap: 15px;
  padding-left: ${({ $isChildProperty }) => $isChildProperty && '106px'};

  ${mediaQuery.xs} {
    padding-left: ${({ $isChildProperty }) => $isChildProperty && '60px'};
  }
`;

export const IntegrationMetadataStyled = styled(Col).attrs(() => ({
  xs: 6,
  md: 4,
}))`
  display: flex;
  align-items: center;
  justify-content: center;

  .text-gray {
    color: ${theme.colors.gray600};
  }

  p {
    margin: 20px 0;
  }
`;

export const PropertyToggleContainerStyled = styled.div`
  height: 32px;

  ${mediaQuery.xs} {
    ${NotAvailableWrapper}, .toggle-switch {
      margin-top: 20px;
    }
  }

  .toggle-switch {
    ${mediaQuery.xs} {
      margin-top: 20px;
    }

    margin-top: 0;
  }
`;

export const PropertyListItemStyled = styled.li.attrs({
  className: 'property-list-item',
  'data-testid': 'property-list-item',
})`
  border-bottom: 1px solid ${theme.colors.gray300};
  padding: 15px;

  :last-child {
    border-bottom: none;
  }
`;

export const PropertyNameStyled = styled.a.attrs({
  'data-testid': 'property-list-item-name',
})`
  color: #495057;
  font-size: 20px;
  font-weight: 700;
`;

export const IconLinkStyled = styled(Link)`
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }

  :hover {
    position: relative;
    ::after {
      content: '';
      position: absolute;

      height: 32px;
      width: 32px;
      border-radius: 50%;
      background-color: ${theme.colors.bgHover};
      top: 0px;
      left: 0px;
      z-index: -1;
    }
  }
`;

export const ActionsColumnStyled = styled(Col).attrs({
  xs: 6,
  md: 3,
})`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
`;
